import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'state/global-state/store';

export const selectCartEntries = ({ ordering }: RootState) => ordering.cart.cartEntries;

export const selectMinimalCartEntries = createSelector(
  [(state: RootState) => state.ordering.cart.minimalCartEntries],
  minimalCartEntries => minimalCartEntries
);
